<template>
  <p>Registration for VIZBI 2013 is now closed.</p>
</template>
